import { createContainer } from 'react-sweet-state';

import { FormatStore } from './FormatStore';

export const FormatStoreContainer = createContainer(FormatStore, {
  onInit:
    () =>
    ({ setState, dispatch }, { state }) => {
      if (state) {
        setState(state);
      }
    },
  onUpdate:
    () =>
    ({ setState }, { state }) => {
      if (state) {
        setState(state);
      }
    },
});
